import { getParsedUserAgent, getPlatformFromUserAgent } from "../util";
import { assessmentLocation, DeviceMetrics, DeviceMetricsPatch, DeviceReadinessInfo, IADPState, ConnectionType } from "../typings";
import { HEADER_ENAEP, NOT_APPLICABLE, NOT_AVAILABLE } from "../util/constants";
import { useFetchService } from "./useFetchService";
import { useSelector } from "react-redux";

export function useDeviceMetricsService() {
    const { fetch } = useFetchService();
    const state = useSelector((state: { rootState: IADPState }) => state.rootState);
    const postDeviceMetrics = async (deviceReadinessInfo: DeviceReadinessInfo,deviceMetricsUrl:string, location?: assessmentLocation) => {
       
        if (state.appState.appLaunchId && (state.sessionState.schoolDetails?.setupCode || state.sessionState.schoolDetails?.verificationCode)) {
            const generatePayload = () => {
                const { appLaunchId, appVersion } = state.appState;
                const { selectedAssessmentMode,appAccessedFor } = state.sessionState;
                const  verificationCode = state.sessionState.schoolDetails?.verificationCode
                const  setupCode =  state.sessionState.schoolDetails?.setupCode
                const { batteryState, deviceType, deviceId } = state.deviceState;
                const { level } = batteryState || {};
        
                return {
                    data: {
                        clientLaunchId: appLaunchId ?? NOT_AVAILABLE,
                        appAccessedFor,
                        deviceModel: state.deviceState.deviceModel ?? NOT_AVAILABLE,
                        setupCode: setupCode?.toUpperCase() ?? NOT_APPLICABLE,
                        verificationCode: verificationCode?.toUpperCase() ?? NOT_AVAILABLE,
                        assessmentDeliveryMode: selectedAssessmentMode,
                        connectionType: state.sessionState.connectionType,
                        launchAgent: window.navigator.userAgent ?? NOT_AVAILABLE,
                        readinessCheckInfo: deviceReadinessInfo ?? state.deviceReadinessState.deviceReadinessInfo,
                        deviceLocalTime: new Date()?.toString(),
                        deviceLocalTimeZone:Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? NOT_AVAILABLE,                  
                        statusInfo: {
                            currentBatteryCharge: level?.toString() ?? "0",
                            lastUpdatedAt: new Date().toISOString(),
                        }
                    },
                    clientDetails: {
                        appName: "ng-enaep-student-app",
                        appVersion: appVersion || NOT_AVAILABLE,
                        deviceDetails: {
                            deviceType: deviceType || "SBE",
                            deviceId: deviceId || NOT_AVAILABLE,
                            operatingSystem: getPlatformFromUserAgent(),
                        }
                    }
                };
            };
            const payload = generatePayload();
            const url = `${deviceMetricsUrl}/${state.appState.appLaunchId}`;
            const isDeviceMetricsPosted = await fetch(url, {
                body: JSON.stringify(payload),
                method: "POST",
                headers: HEADER_ENAEP,
            });
            return isDeviceMetricsPosted;
        }
    };

    const patchDeviceMetrics = async (deviceMetricsUrl:string) => {
        const { setupCode, verificationCode } = state.sessionState.schoolDetails || {};
        if (state.appState.appLaunchId && (setupCode || verificationCode)) {
            if (!setupCode || !verificationCode) return;
            const payload: DeviceMetricsPatch = {
                data: {
                    clientLaunchId: state.appState.appLaunchId ?? NOT_AVAILABLE,
                    appAccessedFor: state.sessionState.appAccessedFor,
                    setupCode: setupCode?.toUpperCase() ?? NOT_AVAILABLE,
                    verificationCode: verificationCode?.toUpperCase() ?? NOT_APPLICABLE,
                    connectionType: state.sessionState.connectionType,
                    launchAgent: window.navigator.userAgent || NOT_AVAILABLE,
                    deviceLocalTime: new Date()?.toString(),
                    deviceLocalTimeZone:Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? NOT_AVAILABLE,                                         
                    statusInfo: {
                        currentBatteryCharge: state.deviceState.batteryState?.level?.toString() || "0",
                    }
                },
                clientDetails: {
                    appName: "ng-enaep-student-app",
                    appVersion: state.appState.appVersion || NOT_AVAILABLE,
                    deviceDetails: {
                        deviceType: state.deviceState.deviceType || "SBE",
                        deviceId: state.deviceState.deviceId || NOT_AVAILABLE,
                        operatingSystem: getPlatformFromUserAgent(),
                    }
                }
            };

            const url = `${deviceMetricsUrl}/${state.appState.appLaunchId}`;
            await fetch(url, {
                body: JSON.stringify(payload),
                method: "PATCH",
                headers: HEADER_ENAEP,
            });
        }
    };

    return { postDeviceMetrics, patchDeviceMetrics };
}
